import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellRing, Loader2 } from "lucide-react";
import { fetchContractSends } from "@/lib/bf";

const when = (iso) => new Date(iso).toLocaleString("ro-RO", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export default function BFContractSends() {
  const [rows, setRows] = useState(null);
  useEffect(() => { fetchContractSends().then((d) => setRows(d.rows)).catch(() => setRows([])); }, []);
  return (
    <section className="invite-box bf-sh" data-testid="bf-contract-sends">
      <h3><BellRing size={18} /> Contracte trimise la semnat</h3>
      <p className="st-hint">Ultimele contracte trimise de agenți. Primești și e-mail la fiecare trimitere.</p>
      {!rows ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p> : !rows.length ? <p className="st-hint" data-testid="bf-cs-empty">Niciun contract trimis încă.</p> : (
        <ul className="bf-sh-list" data-testid="bf-cs-list">
          {rows.map((r, i) => (
            <li key={`${r.lead}-${r.at}-${i}`} className="bf-sh-row" data-testid={`bf-cs-row-${i}`}>
              <div><b>{r.salon || "Salon"}</b><small>{when(r.at)} · de {r.by} · către {r.to}</small>
                <em className={r.signed ? "is-sent" : ""}>{r.signed ? "Semnat la toate 3 firmele" : "Așteaptă semnătura"}</em></div>
              <div className="bf-sh-acts"><Link className="st-btn st-btn--ghost" to={`/client/${r.lead}#contract`} data-testid={`bf-cs-open-${i}`}>Deschide</Link></div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
